import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import { Link } from 'react-router-dom';
import dateformat from 'dateformat';
import { Row, Col } from 'react-bootstrap';

import styles from './GroupSearchView.module.scss';
import GroupDefaultIcon from "src/legacy/images/default_group.jpg";
import DOMPurify from 'dompurify';

import { localizedStrings } from 'src/localization';
import Text from 'src/components/text';

class GroupSearchView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    this.localizedCommons = localizedStrings.commons;
    this.localizedKeywords = localizedStrings.keywords;
  }

  render() {

    return (
      <div>
        <Link to={`/groups/${this.props.id}`} className={styles.groupLink}>
          {this._renderGroupIcon()}
        </Link>
      </div>
    );
  }

  _renderGroupIcon() {
    const group = this.props.group;

    return (
      <Row className={cx(styles.group, this.props.className)}>
        <Col md={12} className={styles.noPadding}>
          <div className={styles.groupContainer}>
            <div>

              {this.renderGroupIcon()}
            </div>
            <div className={styles.descriptionContainer}>
              <div className={styles.truncatedGroupNameWrapper} >
                <Text lines={1}  className={styles.truncatedGroupName} text={DOMPurify.sanitize(`${group.name}`, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] })} />
              </div>
              <Col sm={12} className={cx(styles.groupMetrics, styles.noPadding)}>
                <div className={styles.metrics}>
                  <span className={styles.label}>{this.localizedKeywords.stream}: </span>
                   <Text className={styles.streamName} lines={1} text={group.streamName} />
                </div>
              </Col>
              <Col sm={12} className={cx(styles.author, styles.noPadding)}>
              <span className={styles.createdByNameWrapper}>
                {this.localizedCommons.owner}: <Text className={styles.createdByName} text={this.renderName(group.createdBy)} />
              </span>
                
              </Col>
              <Col sm={12} className={cx(styles.date, styles.noPadding, styles.italicText)}>
                <span>{this.localizedCommons.last_update}: {dateformat(group.modifiedDate, 'dd mmm yyyy')}</span>
              </Col>
            </div>

          </div>

        </Col>
      </Row>
    );
  }

  renderName(user) {
    return `${user.firstName || ''} ${user.lastName || ''}`
  }

  renderGroupIcon() {
    const group = this.props.group;
    var icon = GroupDefaultIcon;

    if (group.icon) {
      icon = group.icon.thumbnail;
    }

    let layerStyle = {
      width: this.props.iconWidth,
      height: (this.props.iconWidth * 1.1667)
    };

    let iconStyle = {
      ...layerStyle,
      'backgroundImage': `url(${icon})`,
    };

    let folderStyle = {
      height: (this.props.iconWidth * 1.1667) + 10
    };

    return (
      <div className={styles.icon}>
        <div style={folderStyle} className={styles.folder}>
          <div style={layerStyle} className={cx(styles.layer, styles.second)}>&nbsp;</div>
          <div style={iconStyle} className={cx(styles.layer, styles.cover)}>
          </div>
        </div>
      </div>
    );
  }
}
export default GroupSearchView;    